import { RoomV2Entity, RoomV2EntityRaw } from "@common/domain";
import { JsonSchemaValidator } from "@common/json-schema-validator";

export class RoomCreateResponseDTO {
  private static validation = JsonSchemaValidator.compile(
    RoomCreateResponseDTO.validationSchema()
  );

  constructor(readonly data: RoomCreateResponseDTORaw) {
    JsonSchemaValidator.assert(RoomCreateResponseDTO.validation, data);
  }

  private static validationSchema() {
    return {
      type: "object",
      required: ["room"],
      properties: {
        room: RoomV2Entity.schema()
      },
      additionalProperties: false
    };
  }
}

export interface RoomCreateResponseDTORaw {
  room: RoomV2EntityRaw;
}
